import React, { FunctionComponent } from 'react';

import styles from './team-schedule.module.scss';
import { IGamePrediction } from 'src/shared/models/interfaces/ipredictions';
import { Table } from 'semantic-ui-react';
import { addAlpha } from '../table.utils';

type TeamSchedulePredictionsProps = {
    teamId: string;
    week?: number;
    data: IGamePrediction[];
};
const TeamSchedulePredictions: FunctionComponent<TeamSchedulePredictionsProps> = (props) => {
    const { teamId, data, week } = props;

    const colorize = (pct: number) => {
        if (pct < 50) return addAlpha('#ff4041', (50 - pct) / 30);
        else if (pct > 50) return addAlpha('#38c172', (pct - 50) / 40);
        else return 'transparent';
    };

    return (
        <Table.Row colSpan={16}>
            <Table.Cell colSpan={16}>
                <div className={styles.container}>
                    <div className={styles.scheduleContainer}>
                        <div className={styles.game}>
                            <div className={styles.scheduleTitle} style={{ height: 20 }}></div>
                            <div className={styles.scheduleTitle} style={{ height: 40 }}>
                                Opponent
                            </div>
                            <div className={styles.scheduleTitle} style={{ height: 40 }}>
                                Win Prob.
                            </div>
                        </div>
                        {data
                            .sort((a, b) => a.week - b.week)
                            .map((game) => {
                                const opponentId =
                                    teamId === game.home_team_id ? game.visitor_team_id : game.home_team_id;
                                const winPct = teamId === game.home_team_id ? game.home_win_pct : game.visitor_win_pct;
                                const teamBackgroundColor = teamId === game.home_team_id ? '#FFFFFF' : '#E7E7E7';

                                let pctText = `${winPct === 100 || winPct === 0 ? winPct : winPct.toFixed(1)}%`;
                                let backgroundColor = colorize(winPct);
                                let color = 'black';
                                let fontWeight = 600;

                                const containerStyle: any = {};
                                let opacity = 1;
                                if (week && game.week < week) {
                                    opacity = 0.45;
                                    backgroundColor = 'transparent';
                                    pctText = winPct === 100 ? 'W' : 'L';
                                    color = winPct === 100 ? '#166E2E' : '#90211E';
                                    fontWeight = 800;
                                }

                                const borderColor = addAlpha('#000000', opacity);

                                return (
                                    <div className={styles.game} key={game.game_key} style={containerStyle}>
                                        <div style={{ fontWeight: 800, opacity }}>{game.week}</div>
                                        <div
                                            className={styles.gameTeam}
                                            style={{ opacity, backgroundColor: teamBackgroundColor, borderColor }}
                                        >
                                            <img
                                                src={require(`../../../../../assets/images/nfl/${opponentId}.png`)}
                                                height={30}
                                                style={{ objectFit: 'contain' }}
                                            />
                                        </div>
                                        <div
                                            className={styles.gameTeam}
                                            style={{
                                                color,
                                                backgroundColor,
                                                fontWeight,
                                                opacity: opacity,
                                                borderColor,
                                            }}
                                        >
                                            {pctText}
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                    <div
                        style={{
                            marginTop: 30,
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                        }}
                    >
                        <div style={{ height: 15, width: 30, backgroundColor: '#E7E7E7', outline: '1px solid #888' }} />
                        <div style={{ marginLeft: 6, fontWeight: 600, color: '#333' }}>= Away</div>
                    </div>
                </div>
            </Table.Cell>
        </Table.Row>
    );
};

export default TeamSchedulePredictions;
